<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title jpn="個人情報保護ポリシー" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">株式会社ゼロプレイス（以下、「当社」といいます。）では、ご利用者様が安心してご利用頂けるよう、最低限の個人情報をご提供頂いております。</span>
            <span class="text">また、当社ではご提供頂いた個人情報の保護について最大限の注意を払っています。</span>
            <br>
            <span class="text">当社の個人情報保護についての考え方は以下の通りとなります。</span>
            <span class="text">(1)当社では会員様により登録された個人及び団体や法人の情報については、最先端の機能やサービスを開発・提供するためにのみ利用し、会員個人情報の保護に細心の注意を払うものとします。</span>
            <span class="text">(2)このプライバシーポリシーの適用範囲は、当社で提供するサービスのみです。</span>
            <span class="text">(3)本規約に明記された場合を除き、目的以外の利用は致しません。</span>
            <span class="text">(4)本規約に明記された場合を除き、第三者への開示は致しません。</span>
            <span class="text">(5)その他本規約に規定された方法での適切な管理を定期的に行います。</span>
            <span class="text">(6)当社は利用者の許可なくして、プライバシーポリシーの変更をすることができます。</span>
            <span class="text">当社が、個人情報取得内容の変更・利用方法の変更・開示内容の変更等をした際には、ご利用者様がその内容を知ることができるよう、当社ホームページのお知らせに公開し、このプライバシーポリシーに反映することにより通知致します。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第1項. 当社のプライバシーポリシーについての考え方が適用される範囲</span>
            <span class="text">(1)当社のプライバシーポリシーについての考え方は、会員が当社のサービスを利用される場合に適用されます。</span>
            <span class="text">(2)会員が当社のサービスを利用される際に収集される個人情報は、当社の個人情報保護についての考え方に従って管理されます。</span>
            <span class="text">(3)当社の個人情報保護の考え方は、当社が直接提供されるサービスのみであり、他の組織や会社等のサービスは適用範囲外となります。</span>
            <span class="text">(4)当社のサービスのご利用は、ご利用者様の責任において行われるものとします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第2項. 当社の個人情報の収集と利用</span>
            <span class="text">(1)当社では会員の皆様に最先端の機能やサービスを開発・提供するために、ご利用者様の幾つかの個人情報が必要となります。</span>
            <span class="text">(2)ご登録メールアドレス・パスワードは、利用者ご自身の責任において管理をお願い致します。</span>
            <span class="text">１. パスワードは定期的に変更し、他人が類推しやすいような名前や生年月日, 電話番号などはお勧め致しません。</span>
            <span class="text">２. 知人・友人などであっても開示・貸与・譲渡しないで下さい。</span>
            <span class="text">(3)収集された個人情報は当社のサービスを提供するために必要な限度においてのみ利用し、次の場合を除き、いかなる第三者にも提供致しません。</span>
            <span class="text">１. クレジットカード会社より、カード不正利用の調査のため照会があった場合。</span>
            <span class="text">２. 会員に対し、広告宣伝のための電子メール等を送付する時。</span>
            <span class="text">３. 個人情報に関する機密保持契約を締結している業務委託会社に対して、ご利用者様に明示した利用目的の達成に必要な範囲で個人情報の取扱いを委託する場合。</span>
            <span class="text">４. 当社における会員の行為が、当社方針、告知、当社の利用規約等に違反している場合に、他の会員、第三者または当社の権利、財産を保護するために必要と認められる時。</span>
            <span class="text">５. 裁判所、行政機関の命令等、その他法律の定めに従って個人情報の開示を求められた場合、または犯罪の捜査,第三者に対する権利侵害の排除若しくはその予防、その他これに準ずる必要性ある時。</span>
            <span class="text">(4)会員は、当社に対し、個人情報を上に定める方法で利用することにつきあらかじめ同意するものとし、異議を述べないものとします。</span>
            <span class="text">(5)また、当社では次のような場合、当社のビジネスパートナーと会員の個人情報を共有する事があります。</span>
            <span class="text">１. 会員向け特別サービスなど、事業的な理由がある場合。この場合、情報を提供する前に会員の同意を求め、同意無しでは提供致しません。</span>
            <span class="text">２. 統計資料作成、市場調査、データ分析を行う場合。この場合、特定個人を判別することができない様に加工した情報だけを提供致します。</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1200px;
  min-height: 100%;
  padding: 30px 20px 0;
  margin: 0 auto;
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
